import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
const walletVuex = createNamespacedHelpers("wallet");
import { address, toNano } from "@ton/core";
export default {
  name: "rewards",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo", "settingInfo"]),
    ...taskVuex.mapState(["taskInfo"]),
    ...walletVuex.mapState(["tonConnect", "isMobile"]),
    // officialTaskListFilter() {
    //   return this.officialTaskList && this.officialTaskList.filter((it) => (it.cyclical === 1 && (it.hasOwnProperty("daily_completion_count") && it.daily_limit_count > 0 ? it.daily_completion_count < it.daily_limit_count : it.completed === 0) && this.selectTab === 0) || (it.cyclical === 1 && (it.hasOwnProperty("daily_completion_count") && it.daily_limit_count > 0 ? it.daily_completion_count >= it.daily_limit_count : it.completed === 1) && this.selectTab === 1) || (it.cyclical === 0 && it.completed === this.selectTab));
    // },
    // extraTaskListFilter() {
    //   return this.extraTaskList && this.extraTaskList.filter((it) => (it.cyclical === 1 && (it.hasOwnProperty("daily_completion_count") && it.daily_limit_count > 0 ? it.daily_completion_count < it.daily_limit_count : it.completed === 0) && this.selectTab === 0) || (it.cyclical === 1 && (it.hasOwnProperty("daily_completion_count") && it.daily_limit_count > 0 ? it.daily_completion_count >= it.daily_limit_count : it.completed === 1) && this.selectTab === 1) || (it.cyclical === 0 && it.completed === this.selectTab));
    // },
    officialTaskListFilter() {
      return this.officialTaskList && this.officialTaskList.filter(it => it.completed === 0 && this.selectTab.value === 0);
    },
    extraTaskListFilter() {
      return this.extraTaskList && this.extraTaskList.filter(it => it.completed === 0 && this.selectTab.value === 0);
    },
    oneTimeTaskFilter() {
      return this.oneTimeTaskList && this.oneTimeTaskList.filter(it => it.completed === 0 && this.selectTab.value === 1);
    },
    dailyTaskFilter() {
      return this.dailyTaskList && this.dailyTaskList.filter(it => it.completed === 0 && this.selectTab.value === 2);
    },
    completedTaskList() {
      const officaialList = this.officialTaskList && this.officialTaskList.filter(it => it.completed === 1 && this.selectTab.value === 0) || [];
      const extraList = this.extraTaskList && this.extraTaskList.filter(it => it.completed === 1 && this.selectTab.value === 0) || [];
      const oneTimeList = this.oneTimeTaskList && this.oneTimeTaskList.filter(it => it.completed === 1 && this.selectTab.value === 1) || [];
      const dailyList = this.dailyTaskList && this.dailyTaskList.filter(it => it.completed === 1 && this.selectTab.value === 2) || [];
      return [...officaialList, ...extraList, ...oneTimeList, ...dailyList];
    },
    officialListOrextraTaskList() {
      return this.extraTaskList || this.officialTaskList;
    }
  },
  data() {
    const tabList = [{
      label: "Partners",
      value: 0,
      tag: 0
    }, {
      label: "One time",
      value: 1,
      tag: 0
    }, {
      label: "Daily",
      value: 2,
      tag: 0
    }];
    return {
      popPromptShow: false,
      //是否显示公共弹窗状态
      popPromptInfo: null,
      //存储公共弹窗的页面信息
      officialTaskList: null,
      //官方任务列表
      extraTaskList: null,
      //非官方任务列表
      oneTimeTaskList: null,
      //一次性任务列表
      dailyTaskList: null,
      //每日任务列表
      selectTab: null,
      adsCountdown: 0,
      adsCountdownTimer: null,
      isContinue: false,
      //弹窗是否显示继续按钮
      isAdcoloudCount: 0,
      ////针对类型为adsgram adcloud openad时 Continue和claim rewards两个按钮当前的切换次数 达到最大切换次数时 一直处于claim rewards按钮直至任务成功为止
      adcoloudCountLimit: 3,
      //针对类型为adsgram adcloud openad时 Continue和claim rewards两个按钮最大切换次数 达到最大切换次数时 一直处于claim rewards按钮直至任务成功为止
      isShowErrorText: false,
      //公共弹窗是否显示错误提示状态
      isShowBtnCancel: false,
      //公共弹窗中是否显示claim按钮状态
      taskPrepareInfo: null,
      //针对类型为stars支付或者ton支付 存储 paymentId
      dailyInfo: null,
      //每日签到在任务页的一些基础信息
      popRewardValue: 0,
      tabList
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.selectTab = this.tabList[0];
          await this.initFn();
          this.cyclicalCountdown();
        }
      },
      deep: true,
      immediate: true
    },
    popPromptShow: {
      handler(bool) {
        if (!bool) {
          this.isContinue = false;
          this.isShowErrorText = false;
          this.isShowBtnCancel = false;
          this.taskPrepareInfo = null;
          if (this.popPromptInfo) {
            this.popPromptInfo.isConfirmLoading = false;
          }
        }
      }
    },
    "oneTimeTaskFilter.length": {
      handler(len) {
        const leng = this.oneTimeTaskList && this.oneTimeTaskList.filter(it => it.completed === 0).length;
        this.tabList[1].tag = leng;
      }
    },
    "dailyTaskFilter.length": {
      handler(len) {
        const leng = this.dailyTaskList && this.dailyTaskList.filter(it => it.completed === 0).length;
        this.tabList[2].tag = leng + Number(!this.dailyInfo.today_completed);
      }
    },
    "officialTaskListFilter.length": {
      handler(len) {
        const offLeng = this.officialTaskList && this.officialTaskList.filter(it => it.completed === 0).slice(0, 4).length;
        const extraLeng = this.extraTaskList && this.extraTaskList.filter(it => it.completed === 0).length;
        this.tabList[0].tag = Number(offLeng) + Number(extraLeng);
      }
    },
    "extraTaskListFilter.length": {
      handler(len) {
        const offLeng = this.officialTaskList && this.officialTaskList.filter(it => it.completed === 0).slice(0, 4).length;
        const extraLeng = this.extraTaskList && this.extraTaskList.filter(it => it.completed === 0).length;
        this.tabList[0].tag = Number(offLeng) + Number(extraLeng);
      }
    },
    "dailyInfo.today_completed": {
      handler(len) {
        const leng = this.dailyTaskList && this.dailyTaskList.filter(it => it.completed === 0).length;
        this.tabList[2].tag = leng + Number(!this.dailyInfo.today_completed);
      }
    }
  },
  methods: {
    ...taskVuex.mapActions(["getTaskList", "doTask", "getTaskPrepare", "openInvoiceStarPay", "getDailySummary"]),
    ...userVuex.mapMutations(["setUserInfo"]),
    async initFn(isGetDaily = true) {
      let oldAdvList = localStorage.getItem("advList");
      if (oldAdvList) {
        oldAdvList = JSON.parse(oldAdvList) ?? null;
      }
      this.officialTaskList = await this.getTaskList({
        adv: 1
      });
      if (oldAdvList && oldAdvList.length > 0) {
        this.officialTaskList = this.mergeSort(oldAdvList, this.officialTaskList);
        this.sortAdvList(this.officialTaskList);
        console.log('xxxxxx');
        console.log(this.officialTaskList);
      }
      localStorage.setItem("advList", JSON.stringify(this.officialTaskList));
      if (isGetDaily) {
        this.dailyInfo = await this.getDailySummary();
      }
      const taskList = await this.getTaskList({
        adv: 0
      });
      const extraTaskList = [];
      const oneTimeTaskList = [];
      const dailyTaskList = [];
      taskList.map(item => {
        if (item.type === "validator" && item.cyclical === 0) {
          oneTimeTaskList.push(item);
        } else if (item.type === "validator" && item.cyclical === 1) {
          dailyTaskList.push(item);
        } else {
          extraTaskList.push(item);
        }
      });
      this.extraTaskList = extraTaskList;
      this.oneTimeTaskList = oneTimeTaskList;
      this.dailyTaskList = dailyTaskList;
      console.log("=======", this.extraTaskList, this.oneTimeTaskList, this.dailyTaskList);
    },
    onTab(item) {
      this.selectTab = item;
    },
    //点击显示弹窗
    onShowTaskPop(item) {
      this.hapticFeedback();
      this.setTaskPopInfo(item);
      if (item.type == "telegram" || item.type == "channel" || item.type === "twitter" || item.type == "payment" && item.target.token === "Stars" || item.type == "payment" && item.target.token === "TON") {
        this.popPromptShow = true;
        return;
      }
      if (item.type === "validator") {
        this.popPromptShow = true;
        return;
      }
      if (item.completed === 1) {
        //adsgram adcloud openad三种类型做完之后就不让打开弹窗
        this.popPromptShow = false;
        return;
      }
      if (item.type == "adsgram" || item.type == "adcloud" || item.type === "openad" || item.type == "monetag" || item.type == "adexium" || item.type == "tads" || item.type == "onclicka" || item.type == "richads" || item.type == "telega" || item.type == "giga") {
        //type 为adsgram adcloud openad这三个时,弹窗显示同时在执行一次相关业务
        this.isAdcoloudCount = 0;
        this.isContinue = false;
        this.popPromptInfo.isConfirmLoading = item.isLoading = true;
        this.adsgramOrAdcloudOrOpenadOpenWay(item);
      }
      this.popPromptShow = true;
    },
    //配置弹窗信息 更新页面直接调用这个函数
    setTaskPopInfo(item) {
      //通用信息配置 及所有弹窗都包含的元素  如果不包含 请在变量中做一些判断 或者剥离出去
      const basicInfo = {
        title: item.title,
        icon: item.icon,
        reward: `${item.reward > 0 ? `<span><img src="${require("@images/icon/icon-hic.png")}" alt=""/> +${this.fmt_pre(item.reward)}</span>` : ""}
        ${item.reward_ticket > 0 ? `<span><img src="${require("@images/icon/icon-pass.png")}" alt=""/> +${this.fmt_pre(item.reward_ticket)}</span>` : ""}
        ${item.reward_stock > 0 ? `<span><img src="${require("@images/icon-stock.png")}" alt=""/> +${this.fmt_pre(item.reward_stock)}</span>` : ""}
        ${item?.reward_giftshard && item.reward_giftshard > 0 ? `<span><img src="${require("@images/icon/icon-giftshare.png")}" alt=""/> +${this.fmt_pre(item.reward_giftshard)}</span>` : ""}
        `,
        isConfirmLoading: item.isLoading,
        error: this.isShowErrorText ? item.check_countdown_prompt : null
      };
      //设置确认按钮文字
      const setConfirmText = item => {
        if (item.completed === 0) {
          if (item.type == "validator") {
            return "Check";
          } else if (this.isContinue) {
            return "Continue";
          } else if (item.type == "telegram" || item.type == "channel") {
            return "Join";
          } else if (item.type == "twitter") {
            return "Follow";
          } else if (item.type == "payment" && item.target.token === "Stars") {
            return "Payment";
          } else if (item.type == "payment" && item.target.token === "TON") {
            if (!this.tonConnect) {
              return "Connect";
            }
            return "Payment";
          } else if (item.type == "miniapp") {
            return "Open";
          } else if (item.type == "page") {
            return "Claim";
          } else if (item.type == "adsgram" || item.type == "adcloud" || item.type == "openad" || item.type == "monetag" || item.type == "adexium" || item.type == "tads" || item.type == "onclicka" || item.type == "richads" || item.type == "telega" || item.type == "giga") {
            return "Claim Rewards";
          }
        } else {
          //完成后 type为telegram channel twitter 能继续打开弹窗 此时的按钮名称
          if (item.type == "telegram" || item.type == "channel" || item.type == "twitter") {
            return "Open";
          }
        }
      };
      //设置取消按钮文字, 目前只在非adsgram adcloud openad显示 其他则直接返回null 代表不显示
      const setCancelText = item => {
        if (item.type == "adsgram" || item.type == "adcloud" || item.type === "openad" || item.type == "monetag" || item.type == "adexium" || item.type == "tads" || item.type == "onclicka" || item.type == "richads" || item.type == "telega" || item.type == "giga") {
          return;
        }
        if (item.type === "validator" && item.target.type === "invite") {
          return "Invite";
        }
        if (item.type === "validator" && item.target.type === "upgrade") {
          return "Upgrade";
        }
        if (item.type === "validator" && item.target.type === "lottery") {
          return "Slots";
        }
        if (this.isShowBtnCancel) {
          return "Claim";
        }
      };
      this.popPromptInfo = {
        ...basicInfo,
        confirmText: setConfirmText(item),
        confirmFn: async () => {
          //执行确认按钮业务
          this.hapticFeedback();
          try {
            if (item.type == "telegram" || item.type == "channel" || item.type === "twitter" || item.type === "miniapp") {
              await this.setTypeTelegramOrChannelOrTwitterOrMiniapp(item);
            } else if (item.type == "adsgram" || item.type == "adcloud" || item.type === "openad" || item.type == "monetag" || item.type == "adexium" || item.type == "tads" || item.type == "onclicka" || item.type == "richads" || item.type == "telega" || item.type == "giga") {
              await this.setAdsgramOrAdcloudOrOpenad(item);
            } else if (item.type == "payment" && item.target.token === "Stars") {
              await this.setPayMentStars(item);
            } else if (item.type == "payment" && item.target.token === "TON") {
              await this.setPayMentTon(item);
            } else if (item.type == "page") {
              this.$router.push(`/${item.target}?id=${item.id}`);
            } else if (item.type == "validator") {
              item.isLoading = this.popPromptInfo.isConfirmLoading = true;
              await this.checkTask(item);
            }
          } catch (err) {}
        },
        cancelText: setCancelText(item),
        //非adsgram adcloud openad时 显示claim 验证任务
        cancelFn: async () => {
          this.hapticFeedback();
          //执行取消按钮业务
          //非adsgram adcloud openad时 显示claim 验证任务
          if (item.type === "validator" && item.target.type === "invite") {
            this.WebApp.openTelegramLink(`https://t.me/share/url?text=Who%20let%20the%20${this.settingInfo.coin}%20out%20&url=https://t.me/${this.settingInfo.botname}/app?startapp=ref_${this.userInfo.ref_code}`);
            return;
          }
          if (item.type === "validator" && item.target.type === "upgrade") {
            this.$router.push("/upgrade");
            return;
          }
          if (item.type === "validator" && item.target.type === "lottery") {
            this.$router.push("/slotMachine");
            return;
          }
          this.popPromptInfo.isCancelLoading = item.isCancelLoading = true;
          let params = {};
          if (item.type == "payment" && (item.target.token === "Stars" || item.target.token === "TON")) {
            if (this.taskPrepareInfo && this.taskPrepareInfo.paymentId) {
              params["value"] = this.taskPrepareInfo.paymentId;
            } else {
              params["value"] = 0;
            }
          }
          await this.checkTask(item, params, "cancel");
        },
        isSmallConfirmBtn: this.isShowBtnCancel,
        //claim出现时 confirm 按钮比例小一点
        isCancelLoading: item.isCancelLoading,
        //claim按钮 loading状态
        remark: item?.remarks
      };
      this.popPromptShow = true;
    },
    //验证任务
    async checkTask(item, params, btnType = "confirm") {
      return new Promise(async (resolve, reject) => {
        const _params = params ? {
          ...params
        } : {};
        try {
          const res = await this.doTask({
            taskId: item.id,
            kind: item.adv == 1 ? "adv" : "",
            adv: item.adv,
            ..._params
          });
          this.isContinue = false;
          if (!res || res && res?.code > 0) {
            if (btnType === "confirm") {
              item.isLoading = false;
              this.popPromptInfo.isConfirmLoading = false;
            } else if (btnType == "cancel") {
              item.isCancelLoading = false;
              this.popPromptInfo.isCancelLoading = false;
            }
            if (item.type != "payment") {
              this.isContinue = true;
            }
            this.setTaskPopInfo(item);
            reject();
            return;
          }
          if (item.reward > 0 && item.reward_stock == 0 && item.reward_ticket == 0 && (!item?.reward_giftshard || item?.reward_giftshard == 0)) {
            this.taskInfo.popReward.reward = item.reward;
            this.taskInfo.popReward.isAnim = true;
            this.taskInfo.popReward.show = true;
          } else {
            // this.taskInfo.popReward.reward = `${item.reward > 0 ? `<div class="pop-multiple-reward__reward hic"><img src="${require("@images/icon/icon-hic.png")}" alt="" />+${this.fmt_pre(item.reward)}</div>` : ""}
            // ${item.reward_ticket > 0 ? `<div class="pop-multiple-reward__reward pass"><img src="${require("@images/icon/icon-pass.png")}" alt="" />+${this.fmt_pre(item.reward_ticket)}</div>` : ""}
            // ${item.reward_stock > 0 ? `<div class="pop-multiple-reward__reward stock"><img src="${require("@images/icon-stock.png")}" alt="" />+${this.fmt_pre(item.reward_stock)}</div>` : ""}
            // `;
            // this.taskInfo.popReward.multiple = true;
            // this.taskInfo.popReward.show = true;
            const rewardInfo = res?.rewardInfo;
            console.log("rewardInfo==========", res, rewardInfo, rewardInfo.giftshard);
            if (!rewardInfo) {
              item.isLoading = false;
              return;
            }
            let gameReward = {};
            if (rewardInfo.coin > 0) {
              gameReward["coin"] = rewardInfo?.coin;
            }
            if (rewardInfo.airdrop_ticket > 0) {
              gameReward["ticket"] = rewardInfo?.airdrop_ticket;
            }
            if (rewardInfo.stock > 0) {
              gameReward["stock"] = rewardInfo?.stock;
            }
            if (JSON.stringify(rewardInfo.giftshard) != "{}") {
              gameReward["giftshard"] = rewardInfo?.giftshard;
            }
            console.log("gameRewardgameRewardgameReward", gameReward);
            this.taskInfo.popReward.reward = gameReward;
            this.taskInfo.popReward.icon = "MORE";
            this.taskInfo.popReward.userInfo = res.userInfo;
            this.taskInfo.popReward.show = true;
          }

          // this.setUserInfo(res.userInfo);
          this.$httpClear("/task/list");
          await this.initFn(false);
          this.isAdcoloudCount = 0;
          if (btnType === "confirm") {
            item.isLoading = false;
            this.popPromptInfo.isConfirmLoading = false;
          } else if (btnType == "cancel") {
            item.isCancelLoading = false;
            this.popPromptInfo.isCancelLoading = false;
          }
          this.setTaskPopInfo(item);
          this.popPromptShow = false;
          resolve();
        } catch (err) {
          console.log("errr====", err);
          item.isLoading = false;
          if (btnType === "confirm") {
            this.popPromptInfo.isConfirmLoading = false;
          } else if (btnType == "cancel") {
            this.popPromptInfo.isCancelLoading = false;
          }
          this.setTaskPopInfo(item);
        }
      });
    },
    //类型为adsgram或者adcloud或者openad 任务流程
    setAdsgramOrAdcloudOrOpenad(item) {
      return new Promise(async (resolve, reject) => {
        if (item.completed === 1) {
          reject();
          return;
        }
        if (item.isLoading) {
          reject();
          return;
        }
        this.popPromptInfo.isConfirmLoading = item.isLoading = true;
        if (this.isContinue) {
          await this.adsgramOrAdcloudOrOpenadOpenWay(item);
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          reject();
          return;
        }
        setTimeout(() => {
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          if (this.adsCountdown <= 0) {
            this.isShowErrorText = false;
            this.checkTask(item);
          } else {
            this.isShowErrorText = true;
            if (this.isAdcoloudCount < this.adcoloudCountLimit) {
              this.isContinue = true;
            }
            this.setTaskPopInfo(item);
          }
          resolve();
        }, 500);
      });
    },
    //类型为telegram或者channel或者twitter或者miniapp任务流程
    async setTypeTelegramOrChannelOrTwitterOrMiniapp(item) {
      return new Promise(async (resolve, reject) => {
        try {
          const linkFn = it => {
            if (it.type == "telegram" || it.type == "channel") {
              _v.WebApp.openTelegramLink(item.url);
            } else if (it.type === "twitter" || it.type === "miniapp") {
              _v.WebApp.openLink(item.url);
            }
          };
          if (item.completed === 1) {
            linkFn(item);
            reject();
            return;
          }
          if (item.isLoading) {
            reject();
            return;
          }
          this.popPromptInfo.isConfirmLoading = item.isLoading = true;
          linkFn(item);
          this.isShowBtnCancel = true;
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.setTaskPopInfo(item);
          resolve();
        } catch (err) {}
      });
    },
    //adsgram || adcloud || openad广告打开方式
    async adsgramOrAdcloudOrOpenadOpenWay(item) {
      if (item.type === "openad") {
        //打开openad广告
        const bool = await this.setOpenadFnc(item);
        this.popPromptInfo.isConfirmLoading = item.isLoading = false;
        if (bool) {
          //已满足观看时长
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
      if (item.type === "adsgram") {
        const bool = await this.setAdsgramFnc(item);
        this.popPromptInfo.isConfirmLoading = item.isLoading = false;
        if (bool) {
          //已满足观看时长
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
      if (item.type === "adcloud") {
        const adsCountdownFnc = () => {
          this.adsCountdown--;
          if (this.adsCountdown > 0) {
            this.adsCountdownTimer = setTimeout(() => {
              adsCountdownFnc();
            }, 1000);
          }
        };
        //打开adcloud
        this.isAdcoloudCount++;
        this.setAdcloudFnc(item);
        this.popPromptInfo.isConfirmLoading = item.isLoading = false;
        if (this.isContinue) {
          this.isContinue = false;
          this.adsCountdown = item.secondary_check_countdown || 10;
        } else {
          this.adsCountdown = item.check_countdown;
        }
        adsCountdownFnc();
        this.setTaskPopInfo(item);
        this.popPromptShow = true;
      }
      if (item.type === "monetag") {
        this.WebApp.BackButton.hide();
        const bool = await this.setAdMonetag(item);
        if (bool) {
          //已满足观看时长
          this.WebApp.BackButton.show();
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
      if (item.type === "adexium") {
        this.WebApp.BackButton.hide();
        const bool = await this.setAdexium(item);
        if (bool) {
          //已满足观看时长
          this.WebApp.BackButton.show();
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
      if (item.type === "tads") {
        this.WebApp.BackButton.hide();
        const bool = await this.setTads(item);
        if (bool) {
          //已满足观看时长
          this.WebApp.BackButton.show();
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
      // if (item.type === "adextra") {
      //   this.WebApp.BackButton.hide();
      //   const bool = await this.setAdextra(item);
      //   if (bool) {
      //     //已满足观看时长
      //     this.WebApp.BackButton.show();
      //     this.popPromptInfo.isConfirmLoading = item.isLoading = false;
      //     this.checkTask(item);
      //   } else {
      //     //this.isContinue = true;
      //     //this.setTaskPopInfo(item);
      //   }
      //   return;
      // }
      if (item.type === "onclicka") {
        this.WebApp.BackButton.hide();
        const bool = await this.setOnclicka(item);
        if (bool) {
          //已满足观看时长
          this.WebApp.BackButton.show();
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
      if (item.type === "richads") {
        this.WebApp.BackButton.hide();
        const bool = await this.setRichads(item);
        if (bool) {
          //已满足观看时长
          this.WebApp.BackButton.show();
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
      if (item.type === "telega") {
        this.WebApp.BackButton.hide();
        const bool = await this.setTelega(item);
        if (bool) {
          //已满足观看时长
          this.WebApp.BackButton.show();
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
      if (item.type === "giga") {
        this.WebApp.BackButton.hide();
        const bool = await this.setGiga(item);
        if (bool) {
          //已满足观看时长
          this.WebApp.BackButton.show();
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.checkTask(item);
        } else {
          //this.isContinue = true;
          //this.setTaskPopInfo(item);
        }
        return;
      }
    },
    //adsgram 广告接入
    async setAdsgramFnc(item) {
      return new Promise(async (resolve, reject) => {
        try {
          const AdController = await window.Adsgram.init({
            blockId: item.url
          });
          await AdController.show().then(async result => {
            resolve(1);
          }).catch(result => {
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            resolve(null);
          });
        } catch (err) {
          this.$toasted.info("Adsgram is temporarily unavailable");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          this.adcloundCountdown = 0;
          this.isAdcoloudCount = 0;
          this.isContinue = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
          reject();
        }
      });
    },
    //openad 广告接入
    async setOpenadFnc(item) {
      return new Promise(async resolve => {
        const adParams = {
          TG: {
            type: 'TMA',
            // TMA, WEB, WEB3,
            isFullscreen: false // true: If your TMA is in fullscreen mode
          },

          wallet: {
            // If you have a web3 wallet components, Optional
            type: '',
            // eth: eth wallet, kaia: line wallet, ton: ton wallet;
            provider: null,
            // here is a provider object after wallet initialization.
            components: '' // web3 wallet components name
          } // If it is required for Telegram TMA application, and the value is true.
        };

        let dataParams = item.url.split("|");
        const adInfo = {
          zoneId: Number(dataParams[0]),
          // example zoneId, please check your own code parameters
          publisherId: Number(dataParams[1]) // example publisherId, please check your own code parameters
          //eventId    : 0,  // Reserved Parameter
        };

        try {
          let res = await window.OpenADTGJsSDK.interactive.init({
            adParams,
            adInfo
          });
          if (res.code !== 0) {
            this.$toasted.clear();
            this.$toasted.error("openad error! Try again");
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            this.popPromptShow = false;
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            return;
          }
          let timer = null;
          let startTime = null; //标记 观看广告起始时间点
          if (res.code === 0) {
            const callbackFunc = {
              // Indicates load ad resource from OpenAD platform, false will be returned if there is no resource to be loaded for the publisher slot/zone
              onAdResourceLoad: e => {
                // 'step1', e = ture / false
              },
              // Indicates the interactive ad is opening
              onAdOpening: e => {
                startTime = new Date().getTime(); //标记 观看广告起始时间点
                // 'step2', e = ture / false
              },

              // Indicates the interactive ad is opened,
              onAdOpened: e => {
                // 'step3',  e = ture / false
              },
              // indicates the interactive ad task is finished, the task is defined by publisher
              onAdTaskFinished: e => {
                const nowTime = new Date().getTime();
                const watchedTime = (nowTime - startTime) / 1000; //标记退出广告所在的时间点
                timer = setTimeout(() => {
                  resolve(watchedTime >= item.check_countdown); //观看广告时长至少要 大于等于check_countdown 否者重新观看
                }, 1000);
                // 'step5',  e = viewAD / click  / close
                // if (!item.completed) this.checkExtralTask(item, adv);
              },

              // Indicates the interactive ad is closing
              onAdClosing: e => {
                console.log("Openad adClosing");
                // 'step6', e = viewAD / click  / close
              },

              // Indicates the interactive ad is closed
              onAdClosed: e => {
                console.log("Openad adClosed");
                // 'step7', e = viewAD / click / close
                // If you want to perform different steps based on different shutdown states, please write the code here.
              },

              // Indicates clicked and jumps
              onAdClick: e => {
                console.log("Openad adClick");
                clearTimeout(timer);
                timer = setTimeout(() => {
                  resolve(true);
                }, item.secondary_check_countdown * 1000);
                // 'step4', e = ture / false
              }
            };

            window.OpenADTGJsSDK.interactive.getRender({
              adInfo,
              cb: callbackFunc
            });
          } else {
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
          }
        } catch (err) {
          this.$toasted.clear();
          this.$toasted.error("openad error! Try again");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
        }
      });
    },
    //adcloud 广告跳转
    async setAdcloudFnc(item) {
      this.WebApp.openLink(item.url);
    },
    async setAdMonetag(item) {
      return new Promise(async (resolve, reject) => {
        try {
          show_9608104().then(() => {
            resolve(1);
          }).catch(() => {
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            resolve(null);
          });
        } catch (err) {
          this.$toasted.info("Monetag is temporarily unavailable");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          this.adcloundCountdown = 0;
          this.isAdcoloudCount = 0;
          this.isContinue = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
          reject();
        }
      });
    },
    async setAdexium(item) {
      return new Promise(async (resolve, reject) => {
        try {
          const adexiumAds = new AdexiumWidget({
            wid: '4d6b87a8-4022-4551-a9d5-4603147a50ca',
            adFormat: 'interstitial',
            isFullScreen: true
          });
          adexiumAds.requestAd('interstitial');
          adexiumAds.on('adReceived', ad => {
            adexiumAds.displayAd(ad); // displaying ad
          });

          const noAdFoundListener = () => {
            console.log('no ad');
            this.$toasted.info("Adexium is temporarily unavailable");
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            this.popPromptShow = false;
            this.isContinue = false;
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            resolve(null);
          };
          adexiumAds.on('noAdFound', noAdFoundListener);
          adexiumAds.on('adClosed', () => {
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            console.log('ad closed');
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            resolve(null);
          });
          adexiumAds.on('adPlaybackCompleted', () => {
            console.log('completed');
            resolve(1);
          });
        } catch (err) {
          this.$toasted.info("Adexium is temporarily unavailable");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          this.adcloundCountdown = 0;
          this.isAdcoloudCount = 0;
          this.isContinue = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
          reject();
        }
      });
    },
    async setTads(item) {
      return new Promise(async (resolve, reject) => {
        try {
          const WIDGET_ID = "626";
          const onShowRewardCallback = result => {
            resolve(1);
          };
          const onAdsNotFound = () => {
            console.log('no ad');
            this.$toasted.info("Tads is temporarily unavailable");
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            this.isContinue = false;
            this.popPromptShow = false;
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            resolve(null);
          };
          const onClickReward = () => {
            console.log('click');
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            resolve(null);
          };
          const adController = window.tads.init({
            widgetId: WIDGET_ID,
            type: 'fullscreen',
            onShowReward: onShowRewardCallback,
            onAdsNotFound: onAdsNotFound,
            onClickReward: onClickReward
          });
          adController.loadAd().then(res => {
            adController.showAd();
          }).catch(result => {
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            resolve(null);
          });
        } catch (err) {
          this.$toasted.info("Tads is temporarily unavailable");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          this.adcloundCountdown = 0;
          this.isAdcoloudCount = 0;
          this.isContinue = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
          reject();
        }
      });
    },
    // async setAdextra(item) {
    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const onError = (e) => {
    //         console.log(e)
    //         console.log('error')
    //         this.popPromptInfo.isConfirmLoading = item.isLoading = false;
    //         item.sort = (item.sort ?? 0) + 100
    //         this.sortAdvList(this.officialTaskList)
    //         resolve(null)
    //       }

    //       const onSuccess = () => {
    //         console.log('success')
    //         resolve(1)
    //       }
    //       p_adextra(onSuccess, onError)
    //     } catch (err) {
    //       this.$toasted.info("Adextra is temporarily unavailable");
    //       this.popPromptInfo.isConfirmLoading = item.isLoading = false;
    //       this.popPromptShow = false;
    //       this.adcloundCountdown = 0;
    //       this.isAdcoloudCount = 0;
    //       this.isContinue = false;
    //       item.sort = (item.sort ?? 0) + 100
    //       this.sortAdvList(this.officialTaskList)
    //       reject();
    //     }
    //   });
    // },
    async setOnclicka(item) {
      return new Promise(async (resolve, reject) => {
        try {
          while (!window.initCdTma) {
            if (Date.now() - start > 10000) {
              console.log('error');
              this.popPromptInfo.isConfirmLoading = item.isLoading = false;
              item.sort = (item.sort ?? 0) + 100;
              this.sortAdvList(this.officialTaskList);
              resolve(null);
              throw new Error('Onclicka SDK load timeout');
            }
            await new Promise(r => setTimeout(r, 200));
          }
          window.initCdTma?.({
            id: 6085789
          }).then(show => {
            window.show = show;
            if (!show) {
              this.popPromptInfo.isConfirmLoading = item.isLoading = false;
              item.sort = (item.sort ?? 0) + 100;
              this.sortAdvList(this.officialTaskList);
              resolve(null);
            }
            window.show?.().then(() => {
              resolve(1);
            }).catch(e => {
              console.log(e);
              this.popPromptInfo.isConfirmLoading = item.isLoading = false;
              item.sort = (item.sort ?? 0) + 100;
              this.sortAdvList(this.officialTaskList);
              resolve(null);
            });
          }).catch(e => {
            console.log(e);
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
          });
        } catch (err) {
          this.$toasted.info("Onclicka is temporarily unavailable");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          this.adcloundCountdown = 0;
          this.isAdcoloudCount = 0;
          this.isContinue = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
          reject();
        }
      });
    },
    async setRichads(item) {
      return new Promise(async (resolve, reject) => {
        try {
          let that = this;
          const originalAddEventListener = EventTarget.prototype.addEventListener;
          let listener = [];
          try {
            EventTarget.prototype.addEventListener = function (type, handler, options) {
              if (this === document && type === 'click') {
                listener.push(handler);
              }
              return originalAddEventListener.call(this, type, handler, options);
            };
            window.TAdsController = new TelegramAdsController();
            await window.TAdsController.initialize({
              pubId: "982447",
              appId: "3501",
              debug: false
            });
            window.TAdsController.triggerInterstitialVideo().then(async result => {
              // ad was clicked
              if (listener) {
                listener.forEach(item => {
                  document.removeEventListener("click", item);
                });
                listener = [];
              }
              resolve(1);
            }).catch(result => {
              this.$toasted.info("Richads is temporarily unavailable");
              if (listener) {
                listener.forEach(item => {
                  document.removeEventListener("click", item);
                });
                listener = [];
              }
              // something went wrong or the advertisement was not found
              this.popPromptInfo.isConfirmLoading = item.isLoading = false;
              this.popPromptShow = false;
              this.isContinue = false;
              item.sort = (item.sort ?? 0) + 100;
              this.sortAdvList(this.officialTaskList);
              resolve(null);
            });
          } catch (e) {
            reject();
          } finally {
            EventTarget.prototype.addEventListener = function (type, handler, options) {
              return originalAddEventListener.call(this, type, handler, options);
            };
          }
        } catch (err) {
          this.$toasted.info("Richads is temporarily unavailable");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          this.adcloundCountdown = 0;
          this.isAdcoloudCount = 0;
          this.isContinue = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
          reject();
        }
      });
    },
    async setTelega(item) {
      return new Promise(async (resolve, reject) => {
        try {
          const start = Date.now();
          // 等待 window.TelegaIn
          while (!window.TelegaIn) {
            if (Date.now() - start > 10000) {
              this.popPromptInfo.isConfirmLoading = item.isLoading = false;
              item.sort = (item.sort ?? 0) + 100;
              this.sortAdvList(this.officialTaskList);
              resolve(null);
            }
            await new Promise(r => setTimeout(r, 200));
          }
          this.telegaAds = window.TelegaIn.AdsController.create_miniapp({
            token: '00921404-d6db-41a6-8e0c-c99d5bdd21c1'
          });
          this.telegaAds.ad_show({
            adBlockUuid: item.url
          }).then(() => {
            resolve(1);
          }).catch(err => {
            this.$toasted.info("Telega is temporarily unavailable");
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            this.popPromptShow = false;
            this.isContinue = false;
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            resolve(null);
          });
        } catch (err) {
          this.$toasted.info("Telega is temporarily unavailable");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          this.adcloundCountdown = 0;
          this.isAdcoloudCount = 0;
          this.isContinue = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
          reject();
        }
      });
    },
    async setGiga(item) {
      return new Promise(async (resolve, reject) => {
        try {
          window.showGiga().then(() => {
            // Your reward logic here
            resolve(1);
          }).catch(e => {
            this.popPromptInfo.isConfirmLoading = item.isLoading = false;
            item.sort = (item.sort ?? 0) + 100;
            this.sortAdvList(this.officialTaskList);
            resolve(null);
          });
        } catch (err) {
          this.$toasted.info("Giga is temporarily unavailable");
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          this.popPromptShow = false;
          this.adcloundCountdown = 0;
          this.isAdcoloudCount = 0;
          this.isContinue = false;
          item.sort = (item.sort ?? 0) + 100;
          this.sortAdvList(this.officialTaskList);
          reject();
        }
      });
    },
    //星星支付任务
    async setPayMentStars(item) {
      this.popPromptInfo.isConfirmLoading = item.isLoading = true;
      const res = await this.getTaskPrepare({
        taskId: item.id,
        kind: item.type
      });
      if (!res) {
        this.popPromptInfo.isConfirmLoading = item.isLoading = false;
        return;
      }
      if (res.chainInfo) {
        this.taskPrepareInfo = res;
        const starRes = await this.openInvoiceStarPay({
          url: res.chainInfo.payment_url
        });
        console.log("starResstarResstarRes", starRes);
        if (!starRes) {
          this.popPromptInfo.isConfirmLoading = item.isLoading = false;
          return;
        }
      } else {
        this.$toasted.success("You have enough balance to make the payment, please click check");
      }
      this.popPromptInfo.isConfirmLoading = item.isLoading = false;
      this.isShowBtnCancel = true;
      this.setTaskPopInfo(item);
    },
    //TON支付任务
    async setPayMentTon(item) {
      this.popPromptInfo.isConfirmLoading = item.loading = true;
      if (!this.tonConnect) {
        this.tonWallet.connectTon();
      }
      const res = await this.getTaskPrepare({
        taskId: item.id,
        kind: item.type,
        address: this.tonWallet.uiAddress
      });
      if (!res) {
        this.popPromptInfo.isConfirmLoading = item.loading = false;
        return;
      }
      if (res.chainInfo) {
        this.tonWallet.sendTransaction([{
          address: res.chainInfo.contract,
          amount: toNano(res.chainInfo.amount).toString(),
          payload: res.chainInfo.raw
        }]);
      } else {
        this.$toasted.success("You have enough balance to make the payment, please click check");
      }
      this.taskPrepareInfo = res;
      this.isShowBtnCancel = true;
      this.popPromptInfo.isConfirmLoading = item.loading = false;
      //this.popPromptInfo.isConfirmLoading = item.isLoading = false;
      this.setTaskPopInfo(item);
    },
    //周期性任务 循环时间
    cyclicalCountdown() {
      clearTimeout(this.taskInfo.taskTimer);
      if (this.officialTaskList) {
        this.officialTaskList.map(item => {
          if (item.cyclical == 1 && item.countdown > 0) {
            item.countdown = item.countdown - 1;
            if (item.countdown <= 0) {
              item.completed = 0;
            }
          }
          return item;
        });
      }
      if (this.extraTaskList) {
        this.extraTaskList.map(item => {
          if (item.cyclical == 1 && item.countdown > 0) {
            item.countdown = item.countdown - 1;
            if (item.countdown <= 0) {
              item.completed = 0;
            }
          }
          return item;
        });
      }
      this.taskInfo.taskTimer = setTimeout(() => {
        this.cyclicalCountdown();
      }, 1000);
    },
    sortAdvList(list) {
      list.sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0));
    },
    mergeSort(array1, array2) {
      // 创建一个Map来存储第一个数组的id和order的映射
      const sortMap = new Map();
      for (const item of array1) {
        sortMap.set(item.id, item.sort);
      }

      // 遍历第二个数组，添加order属性
      return array2.map(item => {
        const sort = sortMap.has(item.id) ? sortMap.get(item.id) : 0;
        return {
          ...item,
          sort
        };
      });
    }
  },
  mounted() {
    this.setWowAnim();
    if (this.$route.query.tab) {
      this.tabList.map(item => {
        if (item.value == this.$route.query.tab) {
          this.onTab(item);
        }
      });
    }
  }
};